import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button
} from "@mui/material";
interface ConfirmDialogProps {
	isOpen: boolean;
	title: string;
	content: string;
	onConfirm: () => void;
	onCancel: () => void;
	primaryButtonText?: string;
	secondaryButtonText?: string;
	primaryButtonColor?: ButtonColors;
	secondaryButtonColor?: ButtonColors;
}
type ButtonColors =
	| "primary"
	| "secondary"
	| "inherit"
	| "error"
	| "info"
	| "success"
	| "warning";
export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
	isOpen,
	title,
	content,
	onConfirm,
	onCancel,
	primaryButtonText = "Confirm",
	secondaryButtonText = "Cancel",
	primaryButtonColor = "primary",
	secondaryButtonColor = "inherit"
}) => {
	return (
		<Dialog open={isOpen} onClose={onCancel}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<p>{content}</p>
			</DialogContent>
			<DialogActions>
				<Button onClick={onCancel} color={secondaryButtonColor}>
					{secondaryButtonText}
				</Button>
				<Button onClick={onConfirm} color={primaryButtonColor}>
					{primaryButtonText}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
